export default __webpack_public_path__ + "static/Modal-0da72b20ae9c0248918fe6723173c1ea.svg";